import React, { useState, useEffect } from "react";

const BackButton = (props) => {
    return (
        <>
            <ul className="backhead">
                <li>
                    <a onClick={() => props.close && props.close()} href="#">
                        <img src="/assets/images/backarrow.svg" className="img_arrow" alt="" />
                    </a>
                </li>
                <li>
                    <h5>Har Ghar Vikas</h5>
                </li>
            </ul>
        </>
    )
}

export default BackButton;